import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EduCategoryService } from 'src/app/service/context/edu/edu-category.service';
import { RemoveUnicode } from 'src/app/admin/shared/ultils';

@Component({
    selector: 'app-edu-category-edit',
    templateUrl: './edu-category-edit.component.html',
    styles: []
})
export class EduCategoryEditComponent implements OnInit {
    constructor(
        private eduCategoryService: EduCategoryService,
        private toastr: ToastrService,
        private route: ActivatedRoute,
        private router: Router
    ) { }

    guid: string;
    parentSelected: {};
    eduCategory: any = {};

    eduCategories: any[] = [];

    ngOnInit() {
        this.guid = this.route.snapshot.paramMap.get('guid');
        this.loadDataListCategory();

        if (this.guid)
            this.loadData();
    }

    loadDataListCategory() {
        this.eduCategories = [];
        this.eduCategoryService.getListEduCategory().subscribe(
            res => {
                let cats = (<any>res);

                cats.sort((a, b) => a['treeLevel'] - b['treeLevel'] || <any>new Date(b['createdAt']) - <any>new Date(a['createdAt']));
                for (const catParent of cats.filter(x => !x.guidParent)) {
                    catParent.children = cats.filter((x) => x.guidParent == catParent.guid);

                    for (const menuChild of catParent.children) {
                        menuChild.children = cats.filter((x) => x.guidParent == menuChild.guid);
                    }

                    this.eduCategories.push(catParent);
                }
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    loadData() {
        this.eduCategoryService.getEduCategoryById(this.guid).subscribe(
            res => {
                if (!res)
                    this.router.navigateByUrl('/techbyte/admin/error');

                this.eduCategory = <any>res;

                if (this.eduCategory.guidParent)
                    this.eduCategoryService.getEduCategoryById(this.eduCategory.guidParent).subscribe(
                        res => {
                            if (!res)
                                this.router.navigateByUrl('/techbyte/admin/error');

                            this.parentSelected = <any>res;
                        },
                        err => {
                            this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                        },
                    );
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    onRefresh() {
        this.loadData();
    }

    onSave() {
        this.eduCategory.seoFriendUrl = RemoveUnicode(this.eduCategory.name);
        if (this.parentSelected)
            this.eduCategory.guidParent = (<any>this.parentSelected).guid;
        document.getElementById('page-loader-data').style.display = "block";
        this.eduCategoryService.saveEduCategory(this.eduCategory).subscribe(
            res => {
                this.toastr.success("Thành công");
                this.router.navigateByUrl('/techbyte/admin/edu-category');
                document.getElementById('page-loader-data').style.display = "none";
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                document.getElementById('page-loader-data').style.display = "none";
            },
        );
    }

    onCancel() {
        this.router.navigateByUrl('/techbyte/admin/edu-category');
    }
}